var _circle, _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResults1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#F1F1F1",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.8989 -2.5056e-08 11.8183 0.413852 9.87706 1.21793C7.93586 2.022 6.17203 3.20055 4.68629 4.68629C3.20055 6.17203 2.022 7.93586 1.21793 9.87707C0.413852 11.8183 -6.67882e-08 13.8989 0 16C6.67882e-08 18.1012 0.413852 20.1817 1.21793 22.1229C2.022 24.0641 3.20055 25.828 4.68629 27.3137C6.17203 28.7994 7.93586 29.978 9.87707 30.7821C11.8183 31.5861 13.8989 32 16 32V30.016C14.1594 30.016 12.3368 29.6535 10.6363 28.9491C8.93581 28.2447 7.3907 27.2123 6.0892 25.9108C4.78769 24.6093 3.75528 23.0642 3.05091 21.3637C2.34654 19.6632 1.98401 17.8406 1.98401 16C1.98401 14.1594 2.34654 12.3368 3.05091 10.6363C3.75528 8.93581 4.78769 7.3907 6.0892 6.0892C7.3907 4.78769 8.93581 3.75528 10.6363 3.05091C12.3368 2.34654 14.1594 1.98401 16 1.98401V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.8989 -2.5056e-08 11.8183 0.413852 9.87706 1.21793C7.93586 2.022 6.17203 3.20055 4.68629 4.68629C3.20055 6.17203 2.022 7.93586 1.21793 9.87707C0.413852 11.8183 -6.67882e-08 13.8989 0 16C6.67882e-08 18.1012 0.413852 20.1817 1.21793 22.1229C2.022 24.0641 3.20055 25.828 4.68629 27.3137C6.17203 28.7994 7.93586 29.978 9.87707 30.7821C11.8183 31.5861 13.8989 32 16 32V30.016C14.1594 30.016 12.3368 29.6535 10.6363 28.9491C8.93581 28.2447 7.3907 27.2123 6.0892 25.9108C4.78769 24.6093 3.75528 23.0642 3.05091 21.3637C2.34654 19.6632 1.98401 17.8406 1.98401 16C1.98401 14.1594 2.34654 12.3368 3.05091 10.6363C3.75528 8.93581 4.78769 7.3907 6.0892 6.0892C7.3907 4.78769 8.93581 3.75528 10.6363 3.05091C12.3368 2.34654 14.1594 1.98401 16 1.98401V0Z",
    stroke: "#50949E",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 10H11.3333C10.597 10 10 10.597 10 11.3333V20.6667C10 21.403 10.597 22 11.3333 22H20.6667C21.403 22 22 21.403 22 20.6667V11.3333C22 10.597 21.403 10 20.6667 10Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 12.667H12.666V18.667H14.666V12.667Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.334 12.667H17.334V16.0003H19.334V12.667Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults1);
export default __webpack_public_path__ + "static/media/results1.ddef51fd2eded4674567c3c27cd58070.svg";
export { ForwardRef as ReactComponent };